export default __webpack_public_path__ + "img/tremors/tremors8_480.webp";